//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import {
  IDynamicLandingPage,
  IDynamicLandingPages,
  IOnePageLink,
} from '@apis/dynamic-landing-pages/dynamicLandingPagesApiModels';
import Cuid from '@models/Cuid';
import { gatewayFetch } from '@utils/sessionFetch';

function gatewayDynamicLandingPagesFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<Response> {
  return gatewayFetch(
    'experience_gateway',
    `/api/v1/dynamic-landing-pages${endpoint}`,
    init,
  );
}

export async function getOrCreateDynamicLandingPage(): Promise<IDynamicLandingPage> {
  const dynamicLandingPages = await getDynamicLandingPages();

  if (dynamicLandingPages?.dynamicLandingPages[0]) {
    // Client should have at most one dynamic landing page, but for
    // legacy support we return an array on the backend. We'll take
    // the head of this list to mimic our patterns on the backend.
    return dynamicLandingPages.dynamicLandingPages[0];
  } else {
    const newDynamicLandingPage = await createDynamicLandingPage();
    return newDynamicLandingPage;
  }
}

export async function generateOnePageLink(
  cuids: Cuid[],
): Promise<IOnePageLink> {
  const res = await gatewayDynamicLandingPagesFetch(`/url`, {
    method: 'POST',
    body: JSON.stringify({
      cuids,
    }),
  });
  return await res.json();
}

async function getDynamicLandingPages(): Promise<IDynamicLandingPages> {
  const res = await gatewayDynamicLandingPagesFetch('', {
    method: 'GET',
  });
  return await res.json();
}

async function createDynamicLandingPage(): Promise<IDynamicLandingPage> {
  const res = await gatewayDynamicLandingPagesFetch('', {
    method: 'POST',
  });
  return await res.json();
}
